module.exports = __webpack_public_path__ + "img/youtube.beec5ec2.svg";